import React from "react";
import classNames from "classnames";

const prefix = "ant-btn-group-";

export default function ButtonGroup(props) {
  const { size, className, ...others } = props;

  // large => lg
  // small => sm
  const sizeCls =
    {
      large: "lg",
      small: "sm"
    }[size] || "";

  const classes = classNames({
    "ant-btn-group": true,
    [prefix + sizeCls]: sizeCls,
    [className]: className
  });

  return (
    <div {...others} ecId={`${others.ecId}_div@t6si6j`} className={classes} />
  );
}

ButtonGroup.propTypes = {
  size: React.PropTypes.oneOf(["large", "default", "small"])
};



// WEBPACK FOOTER //
// ./_antd1.11.2/button/button-group.jsx